import * as Types from './types'

export const SERVER_RESOURCE = '/users'

export const COMMUNITY_ADMIN_ROLE = 'community_admin'
export const COMMUNITY_ADMIN_ROLE_NAME = 'Community Administrator'

export const emptyAddUserModalState: Types.ModalData = {
  email: '',
  icp_guid: '',
  person_roles: [
    {
      id: COMMUNITY_ADMIN_ROLE,
      is_active: true,
      name: COMMUNITY_ADMIN_ROLE_NAME,
    },
  ],
  username: '',
}

export const FETCH_USERS = 'FETCH_USERS'
export const UPDATE_USER = 'UPDATE_USER' // grid update
export const ADD_USER = 'ADD_USER' // add modal
export const EDIT_USER = 'EDIT_USER' // edit modal

export const UPDATE_PERSON_ROLE = 'UPDATE_PERSON_ROLE'

export const USER_RESET_PAYLOAD = {reset_password: true}



// WEBPACK FOOTER //
// ./src/pages/users/constants.ts